import { render, staticRenderFns } from "./adstest.vue?vue&type=template&id=0c178ee8&scoped=true"
import script from "./adstest.vue?vue&type=script&lang=js"
export * from "./adstest.vue?vue&type=script&lang=js"
import style0 from "./adstest.vue?vue&type=style&index=0&id=0c178ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c178ee8",
  null
  
)

export default component.exports